import { Component, OnInit } from '@angular/core';
import { Routes, RouterModule , Router,ActivatedRoute} from '@angular/router';
import { LoaderService } from '../../../../services/loader.service';
import {LeadService} from '../../../lead/lead.service';
import { ActivityLogsService } from '../../../activity-logs/activity-logs.service';
import {Location} from '@angular/common';
import { FormControl,
	FormArray,
	FormBuilder,
	FormGroup,
	Validators } from '@angular/forms';
declare var $:any;

@Component({
  selector: 'app-list-lead-of-leadhead',
  templateUrl: './list-lead-of-leadhead.component.html',
  styleUrls: ['./list-lead-of-leadhead.component.css'],
  providers:[LeadService,ActivityLogsService]
})
export class ListLeadOfLeadheadComponent implements OnInit {

	lead_status;
	lead_type;
	lead_type_id;
	breadcrumval;
	source=[];
	lead_statusArr=[];
	lead_type_idArr=[];
	lead_source_idArr=[];
	lead_campaign_idArr=[];
	csagents_idArr=[];
	filteredLeads=[];
	from_date;
	to_date;
	column_name='created_at';
	successalert = false;
  successMessage : string;
  errorMessage : string;
  erroralert = false;
	role;
	addLeadForm:FormGroup;
	updateLeadForm:FormGroup;
	attachment_file: any;
	attachment_name: string;
	basefile: any;
	updateLeadquestionnaireForm:FormGroup;
	sourceOfBulkLeads="";
	typeOfBulkLeads="";
	campignOfBulkLeads="";
	accommodation_type = ['Studio Apartment','1RK','1BHK','1.5BHK','2BHK','2.5BHK','3BHK',
    '3.5BHK','4BHK','4.5BHK','5BHK','Villa','Bungalow','Office Space'];
  	scopeOfwork = ['Modular Kitchen','Loose Furniture','Full Home Interiors (Design)','Full Home Interiors (Design & Fullfilment)','Partial Home Interiors (e.g. MKW + Living Room)'];
    callbacktime = ['10:00 AM','10:30 AM','11:00 AM','11:30 AM','12:00 PM','12:30 PM','1:00 PM',
                '1:30 PM','2:00 PM','2:30 PM','3:00 PM','3:30 PM','4:00 PM','4:30 PM','5:00 PM',
                '5:30 PM','6:00 PM','6:30 PM','7:00 PM','7:30 PM','8:00 PM','8:30 PM','9:00 PM','9:30 PM',
                '10:00 PM','10:30 PM','11:00 PM'];
    estimatedPossessionTime = ['Jan-18','Feb-18','Mar-18','Apr-18','May-18',
    'Jun-18','Jul-18','Aug-18','Sep-18','Oct-18','Nov-18','Dec-18'];
    queryParamsLeadSource;
    queryParamsLeadCamp;
    queryParamsLeadType;
    queryParamsFromDate;
    queryParamsToDate;
    lostReasonsArr=['low_budget','less_scope_of_work','city_not_in_operations','general_inquiry',
    'language_barrier','reluctant_to_provide_details_wrong_number','others'];
	constructor(
		private route:ActivatedRoute,
		private leadService:LeadService,
		private loaderService:LoaderService,
		private formBuilder:FormBuilder,
		public activityLogsService : ActivityLogsService,
		public router:Router, public location:Location
	) {
		// this.routeChanged();
	 }


	private routeChanged():void {
   	 //var path:string = this.location.path();
   	 	// this.router.navigate([path]);
    	//console.log("Path:" + path);
  	}
  	ngAfterViewInit(){
  	}
	ngOnInit() {
		this.role =localStorage.getItem('user');
		this.route.queryParams.subscribe(params => {
			this.lead_status = params['lead_status'];
			this.lead_type = params['lead_type'];
			this.lead_type_id = params['id'];
			if(params['lead_sources']!=undefined){
				this.queryParamsLeadSource = JSON.parse(params['lead_sources']);
			}
			if(params['lead_campaigns']!=undefined){
				this.queryParamsLeadCamp = JSON.parse(params['lead_campaigns']);
			}
			if(params['lead_types']!=undefined){
				this.queryParamsLeadType = JSON.parse(params['lead_types']);
			}

			this.queryParamsFromDate = params['from_date'];
			this.queryParamsToDate = params['to_date'];

		});
		if(this.queryParamsLeadSource!=undefined && this.queryParamsLeadSource.length>0){
			this.lead_source_idArr=this.queryParamsLeadSource;
		}
		if(this.queryParamsLeadCamp!=undefined && this.queryParamsLeadCamp.length>0){
			this.lead_campaign_idArr=this.queryParamsLeadCamp;
		}
		if(this.queryParamsLeadType!=undefined && this.queryParamsLeadType.length>0){
			this.lead_type_idArr=this.queryParamsLeadType;
		}
		if(this.queryParamsFromDate!=undefined && this.queryParamsFromDate!=''){
			this.from_date=this.queryParamsFromDate;
		}
		if(this.queryParamsToDate!=undefined && this.queryParamsToDate!=''){
			this.to_date=this.queryParamsToDate;
		}
		if(this.lead_type !=undefined){
			this.breadcrumval = this.lead_type;
			if(this.lead_type_id !=undefined){
				this.lead_type_idArr.push(this.lead_type_id);
			}
			this.dropdownSettings["text"] = this.lead_type;
			this.dropdownSettings["disabled"]=true;
			//this.selectedItems.push({id:this.lead_type_id,itemName:this.lead_type});
		}
		if(this.lead_status !=undefined){
			this.breadcrumval = this.lead_status;
			this.lead_statusArr.push(this.lead_status);
			this.dropdownSettings2["text"] = this.lead_status.replace(/_/g, " ").toLowerCase().split(' ').map(x=>x[0].toUpperCase()+x.slice(1)).join(' ');
			this.dropdownSettings2["disabled"]=true;
		}
		if(this.lead_status ==undefined && this.lead_type ==undefined){
			this.breadcrumval ='all';
		}
		this.addLeadForm = this.formBuilder.group({
			name : new FormControl(""),
			email : new FormControl("",[Validators.pattern("^[a-z0-9]+(\.[_a-z0-9]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,15})$")]),
			contact : new FormControl("",[Validators.required]),
			pincode : new FormControl(""),
			lead_type_id : new FormControl("",Validators.required),
		  lead_source_id : new FormControl("",Validators.required),
		  lead_campaign_id:new FormControl(""),
		  instagram_handle: new FormControl(""),
		  lead_type_name:new FormControl()
		});
		this.updateLeadForm = this.formBuilder.group({
			id:new FormControl(""),
			name : new FormControl("",Validators.required),
			email : new FormControl("",[Validators.pattern("^[a-z0-9]+(\.[_a-z0-9]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,15})$")]),
			contact : new FormControl("",[Validators.required]),
			pincode : new FormControl(""),
			lead_type_id : new FormControl("",Validators.required),
      lead_source_id : new FormControl("",Validators.required),
      lead_campaign_id:new FormControl(""),
      lead_status : new FormControl(""),
	    follow_up_time : new FormControl(""),
	    remark: new FormControl(""),
	    lost_remark : new FormControl(""),
	    lost_reason: new FormControl(""),
	    instagram_handle: new FormControl(""),
		  lead_type_name:new FormControl(),
		  lead_cv:new FormControl()
		});
		this.updateLeadquestionnaireForm = this.formBuilder.group({
		  	customer_name : new FormControl("",Validators.required),
		  	phone : new FormControl("",Validators.required),
		  	society:new FormControl(""),
		  	project_name: new FormControl(""),
				pincode: new FormControl(""),
		  	home_type: new FormControl(""),
		  	city : new FormControl(""),
		  	location: new FormControl(""),
		  	project_type :new FormControl(""),
		  	accomodation_type: new FormControl(""),
		  	// scope_of_work : new FormArray([]),
		  	scope_of_work : new FormControl(""),
		  	budget_value:new FormControl(""),
		  	home_value: new FormControl(""),
		  	possession_status :new FormControl(""),
		  	possession_status_date:new FormControl(""),
		  	have_homeloan: new FormControl(""),
		  	call_back_day: new FormControl(""),
		  	call_back_time: new FormControl(""),
		  	have_floorplan: new FormControl(""),
		  	lead_generator: new FormControl(""),
      	lead_source:new FormControl(""),
		  	lead_floorplan:new FormControl(""),
		  	additional_comments :new FormControl(""),
				ownerable_type : new FormControl('Lead'),
				user_id : new FormControl(localStorage.getItem('userId')),
				ownerable_id : new FormControl()
		});

		this.getFiletredLeads(1);
		this.getFiltersData();

	}

	ngOnChanges(){
		window.location.reload();
	}
	csagentsArr;
	lead_campaigns;
	lead_sources;
	lead_types;
	search;
	headers_res;
	per_page;
	total_page;
	current_page;
	page_number;
	getFiletredLeads(pageno?){
		this.page_number = pageno;
		this.loaderService.display(true);
		this.leadService.getFileterLeads(this.source,this.lead_statusArr,this.lead_type_idArr
			,this.lead_source_idArr,this.lead_campaign_idArr,
			this.column_name,this.from_date,this.to_date,this.csagents_idArr,this.search,pageno).subscribe(
			res =>{
				//console.log(res);
				this.headers_res= res.headers._headers;
				this.per_page = this.headers_res.get('x-per-page');
				this.total_page = this.headers_res.get('x-total');
				this.current_page = this.headers_res.get('x-page');

				res= res.json();
				this.filteredLeads = res.leads;
				this.filteredLeads = this.sortFunc(this.filteredLeads,{property: 'id', direction: '-1'});
				
				this.queryParamSelectedArr();
				this.getCmList();

				this.loaderService.display(false);
			},
			err => {
				console.log(err);
				this.loaderService.display(false);
			}
		);
	}

	onChangeOfLeadType(val){
		for(var i=0;i<this.lead_types.length;i++){
			if(val==this.lead_types[i].id){
				this.addLeadForm.controls['lead_type_name'].setValue(this.lead_types[i].name);
			}
		}
	}

	reasonForLostDropdownChange(val){
      if(val=='others'){
        document.getElementById('lostremark').setAttribute('style','display:block');
        this.updateLeadForm.controls['lost_remark'].setValidators([Validators.required]);
      } else {
        if(document.getElementById('lostremark'))
          document.getElementById('lostremark').setAttribute('style','display:none');
          this.updateLeadForm.controls['lost_remark'].setValue("");
          this.updateLeadForm.controls['lost_remark'].validator=null;
      }
      this.updateLeadForm.controls['lost_remark'].updateValueAndValidity();
    }

	getFiltersData(){
		this.leadService.getFiltersData().subscribe(
			res =>{
				res = res.json();
				// console.log(res);
				this.lead_campaigns = res.lead_campaign_id_array
				this.lead_sources= res.lead_source_id_array;
				//this.lead_status=res.lead_status_array
				this.lead_types=	res.lead_type_id_array
				this.csagentsArr = res.cs_agent_list;

				for(var i=0;i<res.lead_type_id_array.length;i++){
					var obj = {
						"id":res.lead_type_id_array[i].id,"itemName":res.lead_type_id_array[i].name.replace("_"," ").toLowerCase().split(' ').map(x=>x[0].toUpperCase()+x.slice(1)).join(' ')
					}
					this.dropdownList.push(obj);
				}
				for(var i=0;i<res.lead_status_array.length;i++){
					var obj = {
						"id":<any>i,"itemName":res.lead_status_array[i].replace(/_/g, " ").toLowerCase().split(' ').map(x=>x[0].toUpperCase()+x.slice(1)).join(' ')
					}
					this.dropdownList2.push(obj);

				}
				for(var i=0;i<res.lead_source_id_array.length;i++){
					var obj = {
						"id":res.lead_source_id_array[i].id,"itemName":res.lead_source_id_array[i].name.replace("_"," ").toLowerCase().split(' ').map(x=>x[0].toUpperCase()+x.slice(1)).join(' ')
					}
					this.dropdownList3.push(obj);
				}
				for(var i=0;i<res.lead_campaign_id_array.length;i++){
					var obj = {
						"id":res.lead_campaign_id_array[i].id,"itemName":res.lead_campaign_id_array[i].name.replace("_"," ").toLowerCase().split(' ').map(x=>x[0].toUpperCase()+x.slice(1)).join(' ')
					}
					this.dropdownList4.push(obj);
				}
				for(var i=0;i<res.cs_agent_list.length;i++){
					var str=(res.cs_agent_list[i].name.replace("_"," ").toLowerCase().split(' ').map(x=>x[0].toUpperCase()+x.slice(1)).join(' '))+' - '+(res.cs_agent_list[i].email)
					var obj = {
						"id":res.cs_agent_list[i].id,"itemName":<any>str
					}
					this.dropdownList5.push(obj);
				}
			}
		);
	}

	direction: number;
    isDesc: boolean = true;
    column: string;
    // Change sort function to this:
    sort(property){
        this.isDesc = !this.isDesc; //change the direction
        this.column = property;
        this.direction = this.isDesc ? 1 : -1;
    }

    sortFunc(records: Array<any>, args?: any){
    	this.column = args.property;
    	this.direction = args.direction;
    	return records.sort(function(a, b){
        if(a[args.property] !=undefined && b[args.property] != undefined) {
          if(args.property=="id"){
             if(a[args.property] < b[args.property]){
                  return -1 * args.direction;
              }
              else if( a[args.property] > b[args.property]){
                  return 1 * args.direction;
              }
              else{
                  return 0;
              }
          } else {
              if(a[args.property].toLowerCase() < b[args.property].toLowerCase()){
                  return -1 * args.direction;
              }
              else if( a[args.property].toLowerCase() > b[args.property].toLowerCase()){
                  return 1 * args.direction;
              }
              else{
                  return 0;
              }
          }
        }
      });
    }
    dropdownList = [];
    dropdownList2=[];
    dropdownList3=[];
    dropdownList4=[];
    dropdownList5=[];
    dropdownList6=[{"id":"created_at","itemName":"Acquisition Date"},{"id":"status_updated_at","itemName":"Status Updated Date"}];

    selectedItems = [];
    selectedItems2=[];
    selectedItems3 = [];
    selectedItems4=[];
    selectedItems5=[];
	selectedItems6=[{"id":"created_at","itemName":"Acquisition Date"}];

    dropdownSettings6 ={
    	singleSelection: true,
	  	// text:" Acquisition Date",
	  	selectAllText:'Select All',
	  	unSelectAllText:'UnSelect All',
	  	enableSearchFilter: true,
	  	classes:"myclass custom-class-dropdown"
    }
    dropdownSettings = {
	  singleSelection: false,
	  text: "Lead Type",
	  selectAllText:'Select All',
	  unSelectAllText:'UnSelect All',
	  enableSearchFilter: true,
	  classes:"myclass custom-class-dropdown",
    };
    dropdownSettings5 ={
    	singleSelection: false,
	  	text:"CS Agent",
	  	selectAllText:'Select All',
	  	unSelectAllText:'UnSelect All',
	  	enableSearchFilter: true,
	  	classes:"myclass custom-class-dropdown"
    }
    dropdownSettings4 ={
    	singleSelection: false,
	  	text:"Campaign",
	  	selectAllText:'Select All',
	  	unSelectAllText:'UnSelect All',
	  	enableSearchFilter: true,
	  	classes:"myclass custom-class-dropdown"
    }
    dropdownSettings3 ={
    	singleSelection: false,
	  	text:"Lead Source ",
	  	selectAllText:'Select All',
	  	unSelectAllText:'UnSelect All',
	  	enableSearchFilter: true,
	  	classes:"myclass custom-class-dropdown"
    }
    dropdownSettings2 ={
    	singleSelection: false,
	  	text:  "Status" ,
	  	selectAllText:'Select All',
	  	unSelectAllText:'UnSelect All',
	  	enableSearchFilter: true,
	  	classes:"myclass custom-class-dropdown",

    }

    queryParamSelectedArr(){
    	if(this.queryParamsLeadSource!=undefined && this.queryParamsLeadSource.length>0){
			for(var i=0;i<this.queryParamsLeadSource.length;i++){
				for(var j=0;j<this.dropdownList3.length;j++){
					if(this.dropdownList3[j].id==this.queryParamsLeadSource[i]){
						this.selectedItems3.push(this.dropdownList3[j]);
					}
				}
			}
		}
		if(this.queryParamsLeadCamp!=undefined && this.queryParamsLeadCamp.length>0){
			for(var i=0;i<this.queryParamsLeadCamp.length;i++){
				for(var j=0;j<this.dropdownList4.length;j++){
					if(this.dropdownList4[j].id==this.queryParamsLeadCamp[i]){
						this.selectedItems4.push(this.dropdownList4[j]);
					}
				}
			}
		}
    }
    onItemSelect(item:any,textVal,index){
    	(document.getElementsByClassName('c-btn')[index]).getElementsByTagName('span')[0].innerHTML='';
        if(textVal=='Status' && index==1){
        	for(var k=0;k<this.selectedItems2.length;k++){
        		(document.getElementsByClassName('c-btn')[index]).getElementsByTagName('span')[0].innerHTML += this.selectedItems2[k].itemName+',';
        	}
        } else if(textVal=='LeadType' && index==0){
        	for(var k=0;k<this.selectedItems.length;k++){
        		(document.getElementsByClassName('c-btn')[index]).getElementsByTagName('span')[0].innerHTML  += this.selectedItems[k].itemName+',';
        	}

        } else if(textVal=='LeadSource' && index==2){
        	for(var k=0;k<this.selectedItems3.length;k++){
        		(document.getElementsByClassName('c-btn')[index]).getElementsByTagName('span')[0].innerHTML  += this.selectedItems3[k].itemName+',';
        	}
        } else if(textVal=='Campaign' && index==3){
        	for(var k=0;k<this.selectedItems4.length;k++){
        		(document.getElementsByClassName('c-btn')[index]).getElementsByTagName('span')[0].innerHTML  += this.selectedItems4[k].itemName+',';
        	}
        }else if(textVal=='Agent' && index==4){
        	for(var k=0;k<this.selectedItems5.length;k++){
        		(document.getElementsByClassName('c-btn')[index]).getElementsByTagName('span')[0].innerHTML  += this.selectedItems5[k].itemName+',';
        	}
        } else if(textVal=='DateColumn' && index==5){
        	for(var k=0;k<this.selectedItems6.length;k++){
        		(document.getElementsByClassName('c-btn')[index]).getElementsByTagName('span')[0].innerHTML  += this.selectedItems6[k].itemName+',';
        	}
        }
    }
    OnItemDeSelect(item:any,textVal,index){
    	(document.getElementsByClassName('c-btn')[index]).getElementsByTagName('span')[0].innerHTML='';
        if(textVal=='Status' && index==1){
        	for(var k=0;k<this.selectedItems2.length;k++){
        		(document.getElementsByClassName('c-btn')[index]).getElementsByTagName('span')[0].innerHTML += this.selectedItems2[k].itemName+',';
        	}
        } else if(textVal=='LeadType' && index==0){
        	for(var k=0;k<this.selectedItems.length;k++){
        		(document.getElementsByClassName('c-btn')[index]).getElementsByTagName('span')[0].innerHTML  += this.selectedItems[k].itemName+',';
        	}

        } else if(textVal=='LeadSource' && index==2){
        	for(var k=0;k<this.selectedItems3.length;k++){
        		(document.getElementsByClassName('c-btn')[index]).getElementsByTagName('span')[0].innerHTML  += this.selectedItems3[k].itemName+',';
        	}
        } else if(textVal=='Campaign' && index==3){
        	for(var k=0;k<this.selectedItems4.length;k++){
        		(document.getElementsByClassName('c-btn')[index]).getElementsByTagName('span')[0].innerHTML  += this.selectedItems4[k].itemName+',';
        	}
        }else if(textVal=='Agent' && index==4){
        	for(var k=0;k<this.selectedItems5.length;k++){
        		(document.getElementsByClassName('c-btn')[index]).getElementsByTagName('span')[0].innerHTML  += this.selectedItems5[k].itemName+',';
        	}
        }  else if(textVal=='DateColumn' && index==5){
        	for(var k=0;k<this.selectedItems6.length;k++){
        		(document.getElementsByClassName('c-btn')[index]).getElementsByTagName('span')[0].innerHTML  += this.selectedItems6[k].itemName+',';
        	}
        }
    }
    onSelectAll(items: any,textVal,index){
        // document.getElementsByClassName('c-btn')[index].innerHTML += item.itemName+',';
        if(textVal=='Status'){
        	console.log(this.selectedItems2);
        } else if(textVal=='LeadType'){
        	console.log(this.selectedItems);
        } else if(textVal=='LeadSource'){
        	console.log(this.selectedItems3);
        } else if(textVal=='Campaign'){
        	console.log(this.selectedItems4);
        } else if(textVal=='Agent'){
        	console.log(this.selectedItems5);
        } else if(textVal=='DateColumn'){
        	console.log(this.selectedItems6);
        }
    }
    onDeSelectAll(items: any,textVal,index){
        console.log(items);
        //document.getElementsByClassName('c-btn')[index].innerHTML += item.itemName+',';
        if(textVal=='Status'){
        	console.log(this.selectedItems2);
        } else if(textVal=='LeadType'){
        	console.log(this.selectedItems);
        } else if(textVal=='LeadSource'){
        	console.log(this.selectedItems3);
        } else if(textVal=='Campaign'){
        	console.log(this.selectedItems4);
        } else if(textVal=='Agent'){
        	console.log(this.selectedItems5);
        } else if(textVal=='DateColumn'){
        	console.log(this.selectedItems6);
        }
    }
    filterData(){
    	this.csagents_idArr.length = 0;
    	this.lead_type_idArr.length=0;
    	this.lead_source_idArr.length=0;
    	this.lead_statusArr.length=0;
    	this.lead_campaign_idArr.length=0;

    	this.loaderService.display(true);
    	for(var k=0;k<this.selectedItems6.length;k++){
    		this.column_name =this.selectedItems6[k].id;
    	}
    	for(var k=0;k<this.selectedItems.length;k++){
    		this.lead_type_idArr.push(this.selectedItems[k].id);
    	}
    	for(var k=0;k<this.selectedItems2.length;k++){
    		this.lead_statusArr.push(this.selectedItems2[k].itemName.toLowerCase().replace(/ /g,"_"));
    	}
    	for(var k=0;k<this.selectedItems3.length;k++){
    		this.lead_source_idArr.push(this.selectedItems3[k].id);
    	}
    	for(var k=0;k<this.selectedItems4.length;k++){
    		this.lead_campaign_idArr.push(this.selectedItems4[k].id);
    	}
    	for(var k=0;k<this.selectedItems5.length;k++){
    		this.csagents_idArr.push(this.selectedItems5[k].id);
    	}

    	this.leadService.getFileterLeads(this.source,this.lead_statusArr,this.lead_type_idArr
			,this.lead_source_idArr,this.lead_campaign_idArr,
			this.column_name,this.from_date,this.to_date,this.csagents_idArr,this.search,1).subscribe(
			res =>{
				this.headers_res= res.headers._headers;
				this.per_page = this.headers_res.get('x-per-page');
				this.total_page = this.headers_res.get('x-total');
				this.current_page = this.headers_res.get('x-page');
				res= res.json();
				this.filteredLeads = res.leads;
				this.loaderService.display(false);

			},
			err=> {
				console.log(err);
				this.loaderService.display(false);

			}
		);
    }

	downloadExcel(){
		this.leadService.exportLeads1(this.role,this.source,this.lead_statusArr,this.lead_type_idArr
			,this.lead_source_idArr,this.lead_campaign_idArr,
			this.column_name,this.from_date,this.to_date,this.csagents_idArr,this.search).subscribe(
		  res =>{
		  	this.successalert = true;
			  this.successMessage = "An email has been sent to your mail id with leads download attachment"
			  setTimeout(function() {
					this.successalert = false;
				 }.bind(this), 9000);
			var contentType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
			var b64Data =  res._body;

			var blob = this.b64toBlob(b64Data, contentType,512);
			var blobUrl = URL.createObjectURL(blob);
			// let blob = new Blob(['\ufeff' + data._body], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
			let dwldLink = document.createElement("a");
			// let url = URL.createObjectURL(blob);
			let isSafariBrowser = navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1;
			if (isSafariBrowser) {  //if Safari open in new window to save file with random filename.
			dwldLink.setAttribute("target", "_blank");
			}
			dwldLink.setAttribute("href", blobUrl);
			dwldLink.setAttribute("download", "lead.xlsx");
			dwldLink.style.visibility = "hidden";
			document.body.appendChild(dwldLink);
			dwldLink.click();
			document.body.removeChild(dwldLink);

		  },
		  err => {
			  console.log(err);
			// this.erroralert = true;
			//   this.errorMessage = <any>JSON.parse(err['_body']).message;
			//   setTimeout(function() {
			// 		this.erroralert = false;
			// 	 }.bind(this), 2000);
		  }
		);
	}
	b64toBlob(b64Data, contentType, sliceSize) {
		contentType = contentType || '';
		sliceSize = sliceSize || 512;

		var byteCharacters = atob(b64Data);
		var byteArrays = [];

		for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
		  var slice = byteCharacters.slice(offset, offset + sliceSize);

		  var byteNumbers = new Array(slice.length);
		  for (var i = 0; i < slice.length; i++) {
			byteNumbers[i] = slice.charCodeAt(i);
		  }

		  var byteArray = new Uint8Array(byteNumbers);

		  byteArrays.push(byteArray);
		}

		var blob = new Blob(byteArrays, {type: contentType});
		return blob;
	}
	addLeadFormSubmit(data) {
		this.loaderService.display(true);
		data['created_by'] = localStorage.getItem('userId');
		data['lead_status']='not_attempted';
		if(this.addLeadForm.controls['lead_type_name'].value=='designer'){
			data['lead_cv']=this.basefile;
		}
		var obj = {
			lead:data
		}
		this.leadService.addLead(obj)
			.subscribe(
			  res => {
				this.addLeadForm.reset();
				$('#addNewLeadModal').modal('hide');
				this.addLeadForm.controls['lead_type_id'].setValue("");
				this.addLeadForm.controls['lead_source_id'].setValue("");
				this.addLeadForm.controls['lead_campaign_id'].setValue("");
				this.basefile = undefined;
				this.getFiletredLeads();
				this.loaderService.display(false);
				this.successalert = true;
				this.successMessage = "Lead created successfully !!";
				setTimeout(function() {
					 this.successalert = false;
				}.bind(this), 2000);
			  },
			  err => {
				this.loaderService.display(false);
				this.erroralert = true;
				this.errorMessage = JSON.parse(err['_body']).message;
				setTimeout(function() {
					 this.erroralert = false;
				}.bind(this), 2000);
			  }
			);
	}
	updateLeadFormSubmit(data){
		if(data.lead_type_name=='designer'){
			data['lead_cv']=this.basefile
		}
		var obj = {
			lead:data
		}
		if( data['lead_status'] == 'qualified' && (data['pincode']=='' || data['pincode'] == null || data['pincode'] ==  undefined)){
      this.errorMessage='Pincode is mandatory';
      this.erroralert = true;
      setTimeout(function() {
            this.erroralert = false;
          }.bind(this), 10000);
    } else {
			this.loaderService.display(true);
			this.leadService.editLead(data.id,obj).subscribe(
				res => {
					this.updateLeadForm.reset();
					$('#editLeadModal').modal('hide');
					this.getFiletredLeads();
					this.loaderService.display(false);
					this.successalert = true;
					this.successMessage = "Details updated successfully !!";
					setTimeout(function() {
						 this.successalert = false;
					}.bind(this), 10000);
				},
				err => {
					console.log(err);
					this.loaderService.display(false);
					this.erroralert = true;
					this.errorMessage = JSON.parse(err['_body']).message;
					setTimeout(function() {
						 this.erroralert = false;
					}.bind(this), 10000);
				}
			);
		}


	}

	setUpdatedLead(value){
		this.updateLeadForm.controls['id'].setValue(value.id);
		this.updateLeadForm.controls['name'].setValue(value.name);
		this.updateLeadForm.controls['email'].setValue(value.email);
		this.updateLeadForm.controls['contact'].setValue(value.contact);
		this.updateLeadForm.controls['pincode'].setValue(value.pincode);
		this.updateLeadForm.controls['lead_type_id'].setValue(value.lead_type_id);
		this.updateLeadForm.controls['lead_source_id'].setValue(value.lead_source_id);
		this.updateLeadForm.controls['lead_campaign_id'].setValue(value.lead_campaign_id);
		this.updateLeadForm.controls['lead_status'].setValue(value.lead_status);
		// this.updateLeadForm.controls['follow_up_time'].setValue(new Date(value.follow_up_time._i).toJSON().slice(0,19));
		this.updateLeadForm.controls['remark'].setValue(value.remark);
		this.updateLeadForm.controls['lost_remark'].setValue(value.lost_remark);
		this.updateLeadForm.controls['lost_reason'].setValue(value.lost_reason);
		this.updateLeadForm.controls['lead_type_name'].setValue(value.lead_type);
		this.updateLeadForm.controls['instagram_handle'].setValue(value.instagram_handle);
		this.updateLeadForm.controls['lead_cv'].setValue(value.lead_cv);
		if(value.lost_reason == 'others'){
          document.getElementById('lostremark').setAttribute('style','display: block');
		}
		else{
			document.getElementById('lostremark').setAttribute('style','display: none');
		}
		if(value.follow_up_time){
			var date=value.follow_up_time.split('T')[0];
    	var time=value.follow_up_time.split('T')[1].split('.')[0];
    	value.follow_up_time = date +"T"+time;
		}
    this.updateLeadForm.controls['follow_up_time'].setValue(value.follow_up_time);
		this.setLeadStatus(value.lead_status);
	}
	setLeadStatus(value) {
	    if(value=='follow_up') {
	    	if(document.getElementById('datetime')){
	      	document.getElementById('datetime').setAttribute('style','display: block');
	    	}
	    	if(document.getElementById('remarkId')){
	      	document.getElementById('remarkId').setAttribute('style','display: block');
	      }

	    } else {
	    	if(document.getElementById('datetime')){
	    		document.getElementById('datetime').setAttribute('style','display: none');
	    	}
	    	if(document.getElementById('remarkId')){
	    		document.getElementById('remarkId').setAttribute('style','display: none');
	    	}
	    }
	    if(value == 'lost') {
	      document.getElementById('addleadFormlostReason').setAttribute('style','display: block');
	    } else {
	      document.getElementById('addleadFormlostReason').setAttribute('style','display: none');
	    }
  	}
	onChange(event) {
		document.getElementById('extErrorMsg').classList.add('d-none');
		this.basefile = undefined;
	   this.attachment_file = event.srcElement.files[0];
	   var re = /(?:\.([^.]+))?$/;
	   var ext = re.exec(this.attachment_file.name)[1];
		var fileReader = new FileReader();
		   var base64;
	   if(ext == 'xlsx' || ext == 'xls') {
			fileReader.onload = (fileLoadedEvent) => {
			 base64 = fileLoadedEvent.target;
			 this.basefile = base64.result;
		   };
		}
		else {
		  document.getElementById('extErrorMsg').classList.remove('d-none');
		}

		fileReader.readAsDataURL(this.attachment_file);
	}
	submitExcelUpload(){
		this.loaderService.display(true);
		this.leadService.uploadLeadExcel(this.basefile,this.sourceOfBulkLeads,this.typeOfBulkLeads,this.campignOfBulkLeads)
		.subscribe(
			res => {
			  $('#exampleModal').modal('hide');
			  this.getFiletredLeads();
			  this.loaderService.display(false);
			  this.sourceOfBulkLeads = "";
			  this.typeOfBulkLeads = "";
			  this.campignOfBulkLeads="";
			  this.successalert = true;
			  this.basefile = undefined;
			  this.successMessage = res['new_leads'].length+" new leads uploaded successfully !!";
			  setTimeout(function() {
					  this.successalert = false;
				 }.bind(this), 5000);
			},
			error => {
			  this.loaderService.display(false);
			  this.erroralert = true;
			  console.log(error);
			  this.errorMessage = JSON.parse(error['_body']).message;
			  setTimeout(function() {
					  this.erroralert = false;
				 }.bind(this), 5000);
			}
		);
	  }

	onDropdownChange(id,value,rowid) {
    	this.assignedAgentId[rowid] = value;
    	if(this.assignedAgentId[rowid] != undefined && this.assignedAgentId[rowid] !='Assign To CS Agent') {
    		document.getElementById("assigndropdown"+id).classList.remove('inputBorder');
    	}
  	}
  	assignedAgentId =[];

	assignLeadToAgent(id:number,index:number){
		if(this.assignedAgentId[index] != undefined && this.assignedAgentId[index] !='Assign To CS Agent') {
		  this.loaderService.display(true);
		  this.leadService.assignLeadToAgent(this.assignedAgentId[index],id)
		            .subscribe(
		        res => {
		          Object.keys(res).map((key)=>{ res= res[key];});
		          //this.getEscalatedLeads();
		          this.assignedAgentId[index] = undefined;
		          this.getFiletredLeads(this.page_number);
		          this.loaderService.display(false);
		          this.successalert = true;
		          this.successMessage = "Assigned Successfully !!";
		          $(window).scrollTop(0);
		          setTimeout(function() {
		                this.successalert = false;
		             }.bind(this), 5000);
		          //$.notify('Assigned Successfully!');
		        },
		        error => {
		          this.erroralert = true;
		          this.errorMessage=JSON.parse(error['_body']).message;
		          this.loaderService.display(false);
		          $(window).scrollTop(0);
		          setTimeout(function() {
		                this.erroralert = false;
		             }.bind(this), 5000);
		          //$.notify(JSON.parse(this.errorMessage['_body']).message);
		        }
		      );
		} else {
		   document.getElementById("assigndropdown"+id).classList.add('inputBorder');
		}
	}

	deleteLead(id) {
	    if(confirm('Are you sure you want to delete this lead?')== true) {
	      this.loaderService.display(true);
	      this.leadService.deleteLead(id)
	        .subscribe(
	          leads => {
	            this.successalert = true;
	            this.successMessage = "Lead deleted successfully";
	            setTimeout(function() {
	                this.successalert = false;
	             }.bind(this), 2000);
	            	this.getFiletredLeads(this.page_number);
	              this.loaderService.display(false);
	            },
	            error =>  {
	              this.erroralert = true;
	              this.errorMessage = <any>JSON.parse(error['_body']).message;
	              setTimeout(function() {
	                this.erroralert = false;
	             }.bind(this), 2000);
	               this.loaderService.display(false);
	            }
	        );
	    }
  	}

  	callToLead(leadId){
	    this.leadService.callToLead(localStorage.getItem('userId'), leadId).subscribe(
	        res => {
	        },
	        err => {
	          console.log(err);
	        }
	     );
	 }

	numberCheck(e) {
	    if(!((e.keyCode > 95 && e.keyCode < 106)
	        || (e.keyCode > 47 && e.keyCode < 58)
	        || e.keyCode == 8 || e.keyCode == 39 ||
	        e.keyCode == 37|| e.keyCode == 38 || e.keyCode == 40 || e.keyCode == 9 || e.keyCode == 17
	        || e.keyCode == 91 || e.keyCode == 86 || e.keyCode == 67 )) {
	      return false;
	    }
  	}

  	userQuestionnaireDetails;
  	leadIDForModal; customerphoneForModal; customerIDModal; customerNameModal;
  	leaddetailsForModal;
  	passDataToModal(LeadIDForModal,customerName,phone,data){
    	this.leadIDForModal = LeadIDForModal;
    	this.customerNameModal = customerName;
    	this.customerphoneForModal = phone;
    	this.leaddetailsForModal = data;
    }
    closeModal(){
			this.leadIDForModal = undefined;
			this.customerNameModal=undefined;
			this.customerphoneForModal = undefined;
	    this.userQuestionnaireDetails =undefined;
	    this.city_others = undefined;
	    this.leaddetailsForModal = undefined;
  	}
  	possesionStatusSelected(val,formName) {
	    if(val == 'Awaiting Possession' && formName=='updateQuestionnaire') {
	      if(document.getElementById('possesiondateupdate')!=null){
	        document.getElementById('possesiondateupdate').style.display = 'block';
	        if(this.leaddetailsForModal.lead_status=='qualified'){
		        this.updateLeadquestionnaireForm.controls['possession_status_date'].setValidators([Validators.required]);
		        this.updateLeadquestionnaireForm.controls['possession_status_date'].updateValueAndValidity();
		      } else {
		        this.updateLeadquestionnaireForm.controls['possession_status_date'].clearValidators();
		        this.updateLeadquestionnaireForm.controls['possession_status_date'].updateValueAndValidity();
		      }
	      }
	    }

	    if(val =='Possession Taken' && formName=='updateQuestionnaire') {
	      if(document.getElementById('possesiondateupdate')!=null){
	        document.getElementById('possesiondateupdate').style.display='none';
	      }
	      this.updateLeadquestionnaireForm.controls['possession_status_date'].setValue(undefined);
	      this.updateLeadquestionnaireForm.controls['possession_status_date'].clearValidators();
      	this.updateLeadquestionnaireForm.controls['possession_status_date'].updateValueAndValidity();
	    }
		}
    getUserQuestionnaireDetails(leadId,status){
      this.loaderService.display(true);
      if(status=='qualified'){
      	this.setFormFieldRequired(this.updateLeadquestionnaireForm);
      } else {
      	this.removeFormFieldRequired(this.updateLeadquestionnaireForm);
    	}
      this.leadService.getRecordNotesQuestionnaire(leadId).subscribe(
        res=>{
        	Object.keys(res).map((key)=>{ res= res[key];});
        	this.userQuestionnaireDetails = res;
          if(this.userQuestionnaireDetails!= null && this.userQuestionnaireDetails.length != 0){
          	this.setQuestionnaireDetails(this.userQuestionnaireDetails[0]);
          } else {
          	this.updateLeadquestionnaireForm.reset();
          	this.updateLeadquestionnaireForm.controls['customer_name'].setValue(this.customerNameModal);
          	this.updateLeadquestionnaireForm.controls['phone'].setValue(this.customerphoneForModal);
          	this.updateLeadquestionnaireForm.controls['society'].setValue("");
				  	this.updateLeadquestionnaireForm.controls['project_name'].setValue("");
				  	this.updateLeadquestionnaireForm.controls['home_type'].setValue("");
				  	this.updateLeadquestionnaireForm.controls['city'].setValue("");
				  	this.updateLeadquestionnaireForm.controls['location'].setValue("");
				  	this.updateLeadquestionnaireForm.controls['project_type'].setValue(""),
				  	this.updateLeadquestionnaireForm.controls['accomodation_type'].setValue("");
				  	this.updateLeadquestionnaireForm.controls['scope_of_work'].setValue("");
				  	this.updateLeadquestionnaireForm.controls['budget_value'].setValue("");
				  	this.updateLeadquestionnaireForm.controls['home_value'].setValue("");
				  	this.updateLeadquestionnaireForm.controls['possession_status'].setValue("");
				  	// remarks_of_sow: new FormControl(),
				  	this.updateLeadquestionnaireForm.controls['possession_status_date'].setValue("");
				  	this.updateLeadquestionnaireForm.controls['have_homeloan'].setValue("");
				  	this.updateLeadquestionnaireForm.controls['call_back_day'].setValue("");
				  	this.updateLeadquestionnaireForm.controls['call_back_time'].setValue("");
				  	this.updateLeadquestionnaireForm.controls['have_floorplan'].setValue("");
				  	this.updateLeadquestionnaireForm.controls['lead_generator'].setValue("");
      			this.updateLeadquestionnaireForm.controls['lead_source'].setValue("");
		  			this.updateLeadquestionnaireForm.controls['lead_floorplan'].setValue("");
		  			this.updateLeadquestionnaireForm.controls['additional_comments'].setValue("");
						this.updateLeadquestionnaireForm.controls['ownerable_type'].setValue('Lead');
						this.updateLeadquestionnaireForm.controls['user_id'].setValue(localStorage.getItem('userId'));
						this.updateLeadquestionnaireForm.controls['ownerable_id'].setValue("");
          	document.getElementById('possesiondateupdate').style.display='none';
          	document.getElementById('floorplanQuestionnaire').style.display = 'none';
          }
          this.loaderService.display(false);
        },
        err=>{
          this.loaderService.display(false);
          console.log(err);
        }
       );
    }

    setFormFieldRequired(formgrp){
    formgrp.controls['society'].setValidators([Validators.required]);
    formgrp.controls['location'].setValidators([Validators.required]);
    formgrp.controls['city'].setValidators([Validators.required]);
    formgrp.controls['project_type'].setValidators([Validators.required]);
    formgrp.controls['call_back_day'].setValidators([Validators.required]);
    // formgrp.controls['call_back_time'].setValidators([Validators.required]);
    formgrp.controls['accomodation_type'].setValidators([Validators.required]);
    formgrp.controls['home_type'].setValidators([Validators.required]);
    formgrp.controls['scope_of_work'].setValidators([Validators.required]);
    formgrp.controls['have_homeloan'].setValidators([Validators.required]);
    formgrp.controls['possession_status'].setValidators([Validators.required]);
    if(formgrp.controls['possession_status'].value=='Awaiting Possession'){
      formgrp.controls['possession_status_date'].setValidators([Validators.required]);
      formgrp.controls['possession_status_date'].updateValueAndValidity();
    } else {
      formgrp.controls['possession_status_date'].clearValidators();
      formgrp.controls['possession_status_date'].updateValueAndValidity();
    }
    formgrp.controls['society'].updateValueAndValidity();
    formgrp.controls['location'].updateValueAndValidity();
    formgrp.controls['city'].updateValueAndValidity();
    formgrp.controls['project_type'].updateValueAndValidity();
    formgrp.controls['call_back_day'].updateValueAndValidity();
    // formgrp.controls['call_back_time'].updateValueAndValidity();
    formgrp.controls['accomodation_type'].updateValueAndValidity();
    formgrp.controls['home_type'].updateValueAndValidity();
    formgrp.controls['scope_of_work'].updateValueAndValidity();
    formgrp.controls['have_homeloan'].updateValueAndValidity();
    formgrp.controls['possession_status'].updateValueAndValidity();
    var elems=document.getElementsByClassName('hideAsteriskIcon');
    for(var i=0;i<elems.length;i++){
      elems[i].setAttribute('style','display:inline');
    }
  }
  removeFormFieldRequired(formgrp){
    formgrp.controls['society'].clearValidators();
    formgrp.controls['location'].clearValidators();
    formgrp.controls['city'].clearValidators();
    formgrp.controls['project_type'].clearValidators();
    formgrp.controls['call_back_day'].clearValidators();
    // formgrp.controls['call_back_time'].clearValidators();
    formgrp.controls['accomodation_type'].clearValidators();
    formgrp.controls['home_type'].clearValidators();
    formgrp.controls['scope_of_work'].clearValidators();
    formgrp.controls['have_homeloan'].clearValidators();
    formgrp.controls['possession_status'].clearValidators();
    formgrp.controls['possession_status_date'].clearValidators();

    formgrp.controls['possession_status_date'].updateValueAndValidity();
    formgrp.controls['society'].updateValueAndValidity();
    formgrp.controls['location'].updateValueAndValidity();
    formgrp.controls['city'].updateValueAndValidity();
    formgrp.controls['project_type'].updateValueAndValidity();
    formgrp.controls['call_back_day'].updateValueAndValidity();
    formgrp.controls['call_back_time'].updateValueAndValidity();
    formgrp.controls['accomodation_type'].updateValueAndValidity();
    formgrp.controls['home_type'].updateValueAndValidity();
    formgrp.controls['scope_of_work'].updateValueAndValidity();
    formgrp.controls['have_homeloan'].updateValueAndValidity();
    formgrp.controls['possession_status'].updateValueAndValidity();
    var elems=document.getElementsByClassName('hideAsteriskIcon')
    for(var i=0;i<elems.length;i++){
      elems[i].setAttribute('style','display:none');
    }
  }
    city_others;
    setQuestionnaireDetails(note_records){
    	if(note_records!=null){
    		if(note_records.customer_name!= null){
    			this.updateLeadquestionnaireForm.controls['customer_name'].setValue(note_records.customer_name);
    		} else {
    			this.updateLeadquestionnaireForm.controls['customer_name'].setValue(this.customerNameModal);
    		}
				if(this.leaddetailsForModal && this.leaddetailsForModal.pincode){
						this.updateLeadquestionnaireForm.controls['pincode'].setValue(this.leaddetailsForModal.pincode);
				}
    		if(note_records.phone!= null){
    			this.updateLeadquestionnaireForm.controls['phone'].setValue(note_records.phone);
    		} else {
    			this.updateLeadquestionnaireForm.controls['phone'].setValue(this.customerphoneForModal);
    		}
	        this.updateLeadquestionnaireForm.controls['project_name'].setValue(note_records.project_name);
	        var elem = this.citiesForQuestionnaire.find(function(e) {
              return e.name == (note_records.city.toLowerCase());
          });
	        if(elem !=undefined){
	        	this.updateLeadquestionnaireForm.controls['city'].setValue(note_records.city.toLowerCase());
	        } else if(note_records.city!='' && note_records.city!=null && note_records.city!=undefined){
	        	this.updateLeadquestionnaireForm.controls['city'].setValue('Other');
	        	this.city_others = note_records.city;
	        	document.getElementById('cityOthersInput').classList.remove('d-none');
	        }
	        else {
	        	this.updateLeadquestionnaireForm.controls['city'].setValue(note_records.city);
	        }
	        this.updateLeadquestionnaireForm.controls['location'].setValue(note_records.location);
	        this.updateLeadquestionnaireForm.controls['project_type'].setValue(note_records.project_type);
	        this.updateLeadquestionnaireForm.controls['accomodation_type'].setValue(note_records.accomodation_type);
	        this.updateLeadquestionnaireForm.controls['home_type'].setValue(note_records.home_type);
	        this.updateLeadquestionnaireForm.controls['society'].setValue(note_records.society);
	        this.updateLeadquestionnaireForm.controls['lead_source'].setValue(note_records.lead_source);
	        this.updateLeadquestionnaireForm.controls['possession_status'].setValue(note_records.possession_status);
	        this.updateLeadquestionnaireForm.controls['possession_status_date'].setValue(note_records.possession_status_date);
	        this.updateLeadquestionnaireForm.controls['home_value'].setValue(note_records.home_value);
	        this.updateLeadquestionnaireForm.controls['budget_value'].setValue(note_records.budget_value);
	        this.updateLeadquestionnaireForm.controls['have_homeloan'].setValue(note_records.have_homeloan);
	        this.updateLeadquestionnaireForm.controls['call_back_day'].setValue(note_records.call_back_day);
	        this.updateLeadquestionnaireForm.controls['call_back_time'].setValue(note_records.call_back_time);
	        this.updateLeadquestionnaireForm.controls['have_floorplan'].setValue(note_records.have_floorplan);
	        this.updateLeadquestionnaireForm.controls['lead_generator'].setValue(note_records.lead_generator);
					this.updateLeadquestionnaireForm.controls['additional_comments'].setValue(note_records.additional_comments);
					this.updateLeadquestionnaireForm.controls['lead_floorplan'].setValue(note_records.lead_floorplan);
					
	      	if(note_records.scope_of_work != null) {
	          // this.updateLeadquestionnaireForm.controls['scope_of_work']['controls']=[];
		        // for(var k=0;k<note_records.scope_of_work.length;k++){
		        //   this.updateLeadquestionnaireForm.controls['scope_of_work']['controls'].push(new FormControl(note_records.scope_of_work[k]));
		        // }
		        if(note_records.scope_of_work.length>0){
		        	this.updateLeadquestionnaireForm.controls['scope_of_work'].setValue(note_records.scope_of_work[0]);
		        }
		        // this.updateLeadquestionnaireForm.controls['scope_of_work'].setValue(note_records.scope_of_work);
		    	}

		    if(note_records.have_floorplan == 'Yes'){
		    	document.getElementById('floorplanQuestionnaire').style.display = 'block';
		    } if(note_records.have_floorplan == 'No'){
		    	document.getElementById('floorplanQuestionnaire').style.display = 'none';
		    }
		    if(note_records.possession_status=='Awaiting Possession'){
		    	document.getElementById('possesiondateupdate').style.display = 'block';
		    }
		    if(note_records.possession_status=='Possession Taken'){
		    	document.getElementById('possesiondateupdate').style.display = 'none';
		    }
		}
    }

    fpQuestionnaireSelected(val){
	    if(val == 'yes'){
	      document.getElementById('floorplanQuestionnaire').style.display = 'block';
	    } else {
	      document.getElementById('floorplanQuestionnaire').style.display = 'none';
	      this.floorplan_attachment_file = undefined;
	      this.questionnaire_floorplan_basefile = undefined;
	    }
	}

	scopeOfWorkSelected(val){
		if(val!='Remarks'){
		  this.updateLeadquestionnaireForm.controls['remarks_of_sow'].setValue(undefined);
		}
	}

	  onCheckChange(event,htmlElemName) {
	    var updateFormArray : FormArray;
	    if(htmlElemName== 'scope_of_work') {
	      updateFormArray = this.updateLeadquestionnaireForm.get('scope_of_work') as FormArray;
	    }
	    /* Selected */
	    if(event.target.checked){
	      updateFormArray.push(new FormControl(event.target.value));
	    }
	    /* unselected */
	    else{
	      var j:number = 0;
	      updateFormArray.controls.forEach((ctr: FormControl) => {
	        if(ctr.value == event.target.value) {
	          // Remove the unselected element from the arrayForm
	          updateFormArray.removeAt(j);
	          return;
	        }

	        j++;
	      });
	      if(event.target.value =='Remarks'){
	        this.updateLeadquestionnaireForm.controls['remarks_of_sow'].setValue("");
	      }
	    }
    }

    questionnaire_floorplan_basefile: any;
  	floorplan_attachment_file:any;

  	onQuestionnaireFloorplanChange(event){
	    this.questionnaire_floorplan_basefile = undefined;
	    this.floorplan_attachment_file = event.srcElement.files[0];
	    var re = /(?:\.([^.]+))?$/;
	    var ext = re.exec(this.floorplan_attachment_file.name)[1];
	    var fileReader = new FileReader();
	    var base64;
	    if(ext == 'jpg' || ext == 'jpeg' || ext=='png' || ext=='gif' || ext=='svg') {
	      fileReader.onload = (fileLoadedEvent) => {
	        base64 = fileLoadedEvent.target;
	        this.questionnaire_floorplan_basefile = base64.result;
	      };
	    } else {
	      document.getElementById('extErrorMsg').classList.remove('d-none');
	    }
	    fileReader.readAsDataURL(this.floorplan_attachment_file);
  	}

  	updateRecordNotesQuestionnaire(leadId,data){
  		if(this.updateLeadquestionnaireForm.controls['city'].value == 'Other'){
      		this.updateLeadquestionnaireForm.controls['city'].setValue(this.city_others);
      		data['city']=this.city_others;
    	}
	    this.loaderService.display(true);
	    this.updateLeadquestionnaireForm.controls['ownerable_id'].setValue(leadId);
	    if(this.userQuestionnaireDetails !=null && this.userQuestionnaireDetails.length!=0){
	    	var noteRecordId = this.userQuestionnaireDetails.id || this.userQuestionnaireDetails[0].id;
	    	data['lead_floorplan'] = this.questionnaire_floorplan_basefile;
	    	data['scope_of_work']=[data['scope_of_work']];
	    	this.leadService.updateRecordNotesQuestionnaire(leadId,data,noteRecordId).subscribe(
		        res => {
		          this.successalert = true;
		          this.successMessage = "Updated successfully !!";
		          $('#questionnaireModal').modal('hide');
		          this.updateLeadquestionnaireForm.reset();
		          this.questionnaire_floorplan_basefile = undefined;
		          this.floorplan_attachment_file = undefined;
		          this.city_others=undefined;
		           setTimeout(function() {
		                 this.successalert = false;
		            }.bind(this), 10000);
		         // this.getUserQuestionnaireDetails(this.leadIDForModal);
		          //Object.keys(res).map((key)=>{ this.leadRecordNotes= res[key];});
		          this.loaderService.display(false);
		        },
		        err => {
		          console.log(err);
		          this.erroralert = true;
		          this.errorMessage = JSON.parse(err['_body']).message;
		          setTimeout(function() {
		                 this.erroralert = false;
		            }.bind(this), 10000);
		          this.loaderService.display(false);
		        }
	      	);
	    }


	    if(this.userQuestionnaireDetails == null || (this.userQuestionnaireDetails !=null && this.userQuestionnaireDetails.length==0)){
	    	data['lead_floorplan'] = this.questionnaire_floorplan_basefile;
				data['scope_of_work']=[data['scope_of_work']];
	    	this.leadService.postRecordNotesQuestionnaire(this.leadIDForModal,data).subscribe(
		        res => {
		          	//Object.keys(res).map((key)=>{ this.userQuestionnaireDetails= res[key];});
		          	this.floorplan_attachment_file = undefined;
		          	this.loaderService.display(false);
		          	this.updateLeadquestionnaireForm.reset();
		          	$('#questionnaireModal').modal('hide');
		          	//this.getUserQuestionnaireDetails(this.leadIDForModal);
		          	//this.setQuestionnaireDetails(this.userQuestionnaireDetails);

		          	this.successalert = true;
		          	this.successMessage = "Form submitted successfully!";
		          	setTimeout(function() {
		              this.successalert = false;
		            }.bind(this), 10000);
		        },
		        err => {
		          console.log(err);
		           this.erroralert = true;
		          this.errorMessage = JSON.parse(err['_body']).message;
		          this.loaderService.display(false);
		          setTimeout(function() {
		              this.erroralert = false;
		            }.bind(this), 10000);
		        }
		      );
	    }
	}

	public lead_logs:any
  	public filtered_logs:any = []
  	public log_owners:any = []
  	clearLogs(){
  		this.lead_logs = undefined;
  		this.filtered_logs = [];
  		this.log_owners = [];
  		$(".dropdownButton1").html('<img src="../../assets/img/images/original/missing.png" class="img-fluid myFluit mr-2" style = "border-radius: 50px;width: 1.5rem;box-shadow: 0 0 0px 2px #ccc;"><span>All (logs)</span>');

  	}
	viewLeadLog(leadId,rowID){
		this.loaderService.display(true);
		this.activityLogsService.getLeadLogs(leadId).subscribe(
	      res => {
	        Object.keys(res).map((key)=>{ this.lead_logs= res[key];})
	        this.filtered_logs = this.lead_logs.change_log;
	        var temp_email = []
	        for (let log of this.lead_logs.change_log){
	          if(log.whodunnit !== "" && log.whodunnit !== null){
	            if(!temp_email.includes(log.whodunnit)){
	              var json = {
	                "name": log.name,
	                "email": log.whodunnit,
	                "image": log.user_image,
	              }
	              this.log_owners.push(json);
	              temp_email.push(log.whodunnit)
	            }

	          }
	        }
	        this.loaderService.display(false);
	      },
	      err => {
	        console.log(err);
	        this.loaderService.display(false);
	      }
    	);
	}
	filterLogs(e,filter = "all"){
	    var arr = [];
	    $(".dropdownButton1").html('<img src="'+e.srcElement.childNodes[1].currentSrc+'" class="img-fluid myFluit mr-2" style = "border-radius: 50px;width: 1.5rem;box-shadow: 0 0 0px 2px #ccc;"><span>'+e.srcElement.childNodes[2].nodeValue+'</span>');
	    if(filter == "all"){
	      this.filtered_logs = this.lead_logs.change_log;
	    }
	    else{
	      for (let log of this.lead_logs.change_log){
	        if(log.whodunnit == filter){
	          arr.push(log)
	        }
	      }
	      this.filtered_logs = arr;

	    }
  	}

  	directionlog: number;
  	isDesclog: boolean = true;
  	columnlog: string = 'CategoryName';
  // Change sort function to this:
  	sortlog(property, sort){
	    if(sort == "oldest"){
	      $(".dropdownButton2").html('Oldest First');
	      this.isDesclog = true; //change the direction
	    }
	    else if(sort == "newest"){
	      $(".dropdownButton2").html('Newest First');
	      this.isDesclog = false; //change the direction
	    }
	    this.columnlog = property;
	    this.directionlog = this.isDesclog ? 1 : -1;
  	}

  	onchangeCity(city){
  		if(city=='Other'){
  			document.getElementById('cityOthersInput').classList.remove('d-none');
  		} else{
  			document.getElementById('cityOthersInput').classList.add('d-none');
  		}
  	}
  	fromDate(){
  		$(".fromDateSpan").hide();
  		$(".fromDate").show();
  	}
  	toDate(){
  		$(".toDateSpan").hide();
  		$(".toDate").show();
  	}

  uploadCV(event) {
    this.attachment_file = event.target.files[0] || event.srcElement.files[0];
    var fileReader = new FileReader();
    var base64;
    fileReader.onload = (fileLoadedEvent) => {
      base64 = fileLoadedEvent.target;
      this.basefile = base64.result;
      //document.getElementById('floorplanImg').setAttribute('src',event.srcElement.files[0].name);
    };
    fileReader.readAsDataURL(this.attachment_file);
  }

  citiesForQuestionnaire;
  getCitiesForQuestionnaire(){
    this.loaderService.display(true);
    this.leadService.getCitiesForQuestionnaire().subscribe(
      res=>{
        this.citiesForQuestionnaire = res.cities;
        this.getUserQuestionnaireDetails(this.leadIDForModal,this.leaddetailsForModal.lead_status);
        this.loaderService.display(false);
      },
      err =>{
        console.log(err);
        this.loaderService.display(false);
      }
    );
  }
  cmlistArr;
  getCmList(){
  	this.loaderService.display(true);
  	this.leadService.getCmList().subscribe(
  		res=>{
  			this.cmlistArr=res.community_managers;
  			this.loaderService.display(false);
  		},
  		err=>{
  			console.log(err);
        this.loaderService.display(false);
  		}
  	);
  }
  assignCmToLead(leadid,index){
  	if(this.assignedCMIds[index] != undefined && this.assignedCMIds[index] !='Assign To CM') {
		  this.loaderService.display(true);
		  this.leadService.assignCmToLead(this.assignedCMIds[index],leadid).subscribe(
        res => {
          Object.keys(res).map((key)=>{ res= res[key];});
          this.assignedCMIds[index] = undefined;
          this.getFiletredLeads(this.page_number);
          this.loaderService.display(false);
          this.successalert = true;
          this.successMessage = "Assigned Successfully !!";
          $(window).scrollTop(0);
          setTimeout(function() {
                this.successalert = false;
             }.bind(this), 5000);
        },
        error => {
          this.erroralert = true;
          this.errorMessage=JSON.parse(error['_body']).message;
          this.loaderService.display(false);
          $(window).scrollTop(0);
          setTimeout(function() {
                this.erroralert = false;
             }.bind(this), 5000);
        }
      );
		} else {
		  document.getElementById("assigncmdropdown"+leadid).classList.add('inputBorder');
		}
  }
  assignedCMIds =[];
  onCMDropdownChange(leadid,cmid,rowid){
  	this.assignedCMIds[rowid] = cmid;
  	if(this.assignedCMIds[rowid] != undefined && this.assignedCMIds[rowid] !='Assign To CM') {
  		document.getElementById("assigncmdropdown"+leadid).classList.remove('inputBorder');
  	}
  }
}



// WEBPACK FOOTER //
// /Users/shobhit/Documents/codes/arrivae-frontend/src/app/platform/organisation/lead-head/list-lead-of-leadhead/list-lead-of-leadhead.component.ts